import { requests } from '../../../utils';
import { DOWNLOAD_INVOICE, INFLUENCER_INVOICE } from '../../../utils/endpoints';
import { BaseModel } from '../../../model/shared/BaseModel';
import { Campaign } from '../../../model/campaign/Campaign';

export const InfluencerInvoiceService = {
    postInvoice: (params: any, campaignId: number, userId: number): Promise<any> =>
        requests.post(INFLUENCER_INVOICE + '/' + campaignId + '/' + userId, params),
    getInvoiceCampaigns: (params: any): Promise<any> =>
        requests.get(INFLUENCER_INVOICE + '/dropdown/campaigns', params),
    getInvoiceArchive: (params: any): Promise<BaseModel<Campaign[]>> =>
        requests.get(INFLUENCER_INVOICE + '/archive', params),
    downloadInvoice: (id: number): Promise<any> => requests.get(DOWNLOAD_INVOICE + '/' + id),
    deleteInvoice: (id: number): Promise<any> => requests.delete(INFLUENCER_INVOICE + '/' + id),
};
